import templateUrl from './listview-grid.tpl.html';

angular
    .module('festzelt-os.components')
    .component('listviewGrid', {
        bindings: {
            store: '=',
        },
        controller() {
            this.lodash = _;
            this.$onInit = () => {
            }
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/listview/grid/listview-grid.js